import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'

import UserAvatarWithStats from 'app/components/UserAvatarWithStats'
import { getIdentityProgressAllCompletedCount } from 'store/entities/identity/selectors'
import NumbersAnimationProvider from 'app/components/AnimationProviders/NumbersAnimationProvider'

import './styles.scss'

const bc = 'user-board-commit-details'

const mapStateToProps = state => ({
  animate: {
    completedCount: {
      from: 0,
      to: getIdentityProgressAllCompletedCount(state),
      duration: 1200,
      int: true,
      easing: 'in-sine',
    },
  },
})

const UserBoardActivityStatsCommitDetails = ({ t, completedCount }) => (
  <div className="prohabit__part prohabit__part-home prohabit__part--left prohabit__part--left-home">
    <div className={bc}>
      <UserAvatarWithStats />
      <div className="stats stats-home">
        <div className="stats__days">
          <span className={classNames({ stats__current: true, 'stats__current--no-streak': !completedCount })}>
            {completedCount || 0}
          </span>
        </div>
        <div className="stats__title stats__title-home">{t('Activities Completed')}</div>
      </div>
    </div>
  </div>
)

export default withTranslation('user')(
  connect(mapStateToProps)(NumbersAnimationProvider(UserBoardActivityStatsCommitDetails))
)
